// extracted by mini-css-extract-plugin
export default {"colorField":"ConfigForm_colorField__lv-M3","colorInput":"ConfigForm_colorInput__1qV7v","colorHex":"ConfigForm_colorHex__uYYSh","actions":"ConfigForm_actions__Y9Kjn"};